import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getArticleReferences } from "axios-client";
import React from "react";
import DashboardLayout from "reusableComponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "reusableComponents/Navbars/DashboardNavbar";

const References = () => {
  const { id } = useParams();
  const [references, setReferences] = useState([]);
  const [citations, setCitations] = useState([]);
  const [article, setArticle] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const direction = "rtl";
  const textAlign = "right";

    const openArticle = (articleId) => {
        if (!articleId) return;
        window.open(`/article/${articleId}`, "_blank");
  };

  useEffect(() => {
    if (!id) return;

    const fetchReferences = async () => {
      try {
        setLoading(true);
        const res = await getArticleReferences(id);
        setArticle(res.data.article || null);
        setReferences(res.data.references || []);
        setCitations(res.data.citations || []);
      } catch (err) {
        console.error(err);
        setError("Failed to load article data");
      } finally {
        setLoading(false);
      }
    };

    fetchReferences();
  }, [id]);

  if (loading) return <p>Loading references…</p>;
  if (error) return <p>{error}</p>;

return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ padding: 24 }}>
        {article && (
          <div style={{ marginBottom: 32 }}>
            <h1>{article.title}</h1>
            { article.author &&
            <p><strong>Authors:</strong> {article.authors}</p>
            }
            {article.publication_date &&
            <p><strong>Published:</strong> {article.publication_date}</p>
            }
            {article.pages_number &&
            <p><strong>Pages:</strong> {article.pages_number}</p>
            }
          </div>
        )}

        <h2 style={{ marginTop: 32 }}>Citations ({citations.length})</h2>
        {citations.length === 0 ? (
          <p>No citations found.</p>
        ) : (
          <ul style={{direction: direction, textAlign: textAlign}}>
            {citations.map((cit) => (
              <li key={cit.id} style={{ marginBottom: 12 }}>
                <div>
                  {cit.linked_article_id ? (
                    <span
                      style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
                      onClick={() => openArticle(cit.source_article.id)}
                    >
                      <span>{cit.source_article.title}</span>
                    </span>
                  ) : (
                    <span>{cit.source_article.title}</span>
                  )}
                  {cit.source_article.authors ? ` - ${cit.source_article.authors}` : ""}
                </div>
              
              </li>
            ))}
          </ul>
        )}
        
        <h2>References ({references.length})</h2>
        {references.length === 0 ? (
          <p>No references found.</p>
        ) : (
          <ul style={{direction: direction, textAlign: textAlign}}>
            {references.map((ref) => (
              <li key={ref.id} style={{ marginBottom: 12 }}>
                <div>
                  {ref.linked_article_id ? (
                    <span
                      style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
                      onClick={() => openArticle(ref.linked_article_id)}
                    >
                      {ref.content}
                    </span>
                  ) : (
                    <span>{ref.content}</span>
                  )}
                  {ref.authors ? ` - ${ref.authors}` : ""}
                </div>
                <div style={{ fontSize: "0.875rem", color: "grey" }}>
                  {ref.publication_year} - {ref.source_type}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </DashboardLayout>
  );
};

export default References;